// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sortable thead th {
  cursor: pointer;
}
.sortable thead th.no-sort {
  pointer-events: none;
}
.sortable thead th::after,
.sortable thead th::before {
  transition: color 0.2s ease-in-out;
  font-size: 1.2em;
  color: transparent;
}
.sortable thead th:not(.no-sort)::after {
  margin-left: 3px;
  content: "\\2195"; /*"\\025B8";*/
}

.sortable thead th:hover::after {
  color: inherit;
}
.sortable thead th.dir-d::after {
  color: inherit;
  content: "\\2191"; /*\\"025BE";*/
}
.sortable thead th.dir-u::after {
  color: inherit;
  content: "\\2193"; /*"\\025B4";*/
}

.sortable td {
  vertical-align: middle;
}

/* paging */

.disable-paging-btn {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/htmlTable.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB,EAAE,YAAY;AAChC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB,EAAE,YAAY;AAChC;AACA;EACE,cAAc;EACd,gBAAgB,EAAE,YAAY;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;;AAEX;EACE,oBAAoB;AACtB","sourcesContent":[".sortable thead th {\n  cursor: pointer;\n}\n.sortable thead th.no-sort {\n  pointer-events: none;\n}\n.sortable thead th::after,\n.sortable thead th::before {\n  transition: color 0.2s ease-in-out;\n  font-size: 1.2em;\n  color: transparent;\n}\n.sortable thead th:not(.no-sort)::after {\n  margin-left: 3px;\n  content: \"\\2195\"; /*\"\\025B8\";*/\n}\n\n.sortable thead th:hover::after {\n  color: inherit;\n}\n.sortable thead th.dir-d::after {\n  color: inherit;\n  content: \"\\2191\"; /*\\\"025BE\";*/\n}\n.sortable thead th.dir-u::after {\n  color: inherit;\n  content: \"\\2193\"; /*\"\\025B4\";*/\n}\n\n.sortable td {\n  vertical-align: middle;\n}\n\n/* paging */\n\n.disable-paging-btn {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
